import React, { forwardRef, ReactNode } from 'react';
import type { HeadingType } from './Heading.data';
import { StyledHeading } from './Heading.styles';

export { HeadingType } from './Heading.data';

export type HeadingProps = {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  forwardedAs?: string | React.ComponentType<any>;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  as?: string | React.ComponentType<any>;
  children: ReactNode;
  type?: HeadingType;
};

export const Heading = forwardRef<HTMLHeadingElement, HeadingProps>(function Heading(
  { forwardedAs, as = forwardedAs || 'h1', type = as, children, ...props },
  ref,
) {
  return (
    <StyledHeading {...props} $type={type} as={as} ref={ref}>
      {children}
    </StyledHeading>
  );
});
